export class SupplierQualityProduct {
    id = 0;
    supplierQualityId = 0;
    productName = "";

    constructor() {}
}